import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { BackOffServiceService } from 'src/app/services/back-off-service.service';
import * as Parse from 'parse';
import { environment } from 'src/environments/environment';
import { CookieService } from 'ngx-cookie-service';


@Component({
  selector: 'app-demographyscore',
  templateUrl: './demographyscore.component.html',
  styleUrls: ['./demographyscore.component.css']
})
export class DemographyscoreComponent implements OnInit {
  score : Number = Number(this.cookie.get("demoScore"));
  atRisk : boolean = false;

  constructor(
    private router : Router,
    private _bkoffService : BackOffServiceService,
    private cookie : CookieService
  ) {
    Parse.initialize(environment.PARSE_APP_ID, environment.PARSE_JS_KEY);
    (Parse as any).serverURL = environment.serverURL;
   }

  ngOnInit() {
    console.log(this.score);
  }

  gotoHome(){
    this.router.navigateByUrl('/motivationquiz');
  }
}
